// \\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\
// OTRM Tme
// DEFAULT
const Theme = {
    styles: {
    },
};

export default Theme;
